import { LOCALES } from 'src/composables/const';

import enUS from './en-US';

export default {
  [LOCALES.EN_US]: enUS,
};
